const PageTransition = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default PageTransition;
